export default "__VITE_ASSET__Bai$22Kf__"